export const messages_es = {
    nameEmpty: "El nombre no puede estar vacío.",
    emailEmpty: "La dirección de e-mail no puede estar vacía.",
    emailNotValid: "La dirección de e-mail no es válida; por favor, introduce una dirección de e-mail adecuada.",
    locationEmpty: "La ubicación no puede estar vacía.",
    interests: "Selecciona 3 áreas de interés.",
    profileSaved: "Datos del perfil guardados.",
    profilePic: "Foto del perfil guardada.",
    addToFavorites:"Añadido correctamente a tu favorito",
    removeFromFavorites:"Eliminado correctamente de tu favorito"
};


// WEBPACK FOOTER //
// ./src/constants/messages_es.js